'use client'
import React from 'react'
import { getOSInfoClient } from 'fuse_common/utils/os/os-client'
import { FuseAppStoreUrl, FusePlayStoreUrl } from 'fuse_common/utils/routing/app-stores'
import { typeRoute } from 'fuse_common/utils/routing/type-route'
import { Trans } from '@lingui/react'
import { LandingButton } from '../controls/landing-button'

export const AppDownloadFloater: React.FC = () => {
  const link = React.useMemo(() => {
    const osInfo = getOSInfoClient()
    if (osInfo.name === 'iOS' && osInfo.osMajorVersion && osInfo.osMajorVersion >= 16) {
      return FuseAppStoreUrl
    }

    if (osInfo.name === 'Android') {
      return FusePlayStoreUrl
    }

    // TODO(johan): Fix once the /app route is implemented as part of https://github.com/Tesseract-Energy/js_monorepo/pull/1613
    // (can be done before merging this PR if that PR is merged first)
    return typeRoute('/app' as any)
  }, [])

  if (process.env.NODE_ENV === 'development' || process.env.NEXT_PUBLIC_ENVIRONMENT === 'test') {
    return (
      <div className="fixed md:hidden top-0 left-0 w-full h-[100dvh] flex flex-col justify-end z-10 p-4 pointer-events-none">
        <LandingButton large className="pointer-events-auto" href={link}>
          <Trans id="landing.floater.cta" />
        </LandingButton>
      </div>
    )
  }
}
